// src/components/ConsistencyScore.jsx
import React from "react";
import { scoreColor, scoreLabel } from "../utils/consistencyScore";

export default function ConsistencyScore({ score }) {
  const display = score ?? 0;
  const color   = scoreColor(display);
  const label   = scoreLabel(display);

  const circumference = 2 * Math.PI * 36;
  const dashOffset    = circumference - (display / 100) * circumference;

  return (
    <div className="card flex flex-col items-center justify-center py-4">
      <div className="text-xs text-slate-500 uppercase tracking-wider mb-3">Consistency Score</div>

      {/* Ring */}
      <div className="relative w-24 h-24">
        <svg className="w-24 h-24 -rotate-90" viewBox="0 0 80 80">
          <circle cx="40" cy="40" r="36" fill="none" stroke="#1f2a3c" strokeWidth="6" />
          <circle
            cx="40" cy="40" r="36" fill="none"
            stroke={display >= 80 ? "#10b981" : display >= 50 ? "#eab308" : "#ef4444"}
            strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            style={{ transition: "stroke-dashoffset 0.8s ease" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className={`text-2xl font-bold leading-none ${color}`}
                style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            {display}
          </span>
          <span className="text-[10px] text-slate-500 mt-0.5">/ 100</span>
        </div>
      </div>

      <div className={`text-xs font-semibold mt-2 ${color}`}>{label}</div>
      <div className="text-[10px] text-slate-600 mt-1 text-center px-2">Last 30 days</div>
    </div>
  );
}
